document.addEventListener('DOMContentLoaded', () => {
  const stories = document.querySelector('.orsay-stories');
  if (!stories) return;
  document.querySelectorAll('.orsay-thumbnail-story')?.forEach((story, index) => {
    story.addEventListener('click', (event) => {
      stories.querySelector(
        '.orsay-stories__feed-container'
      ).style.transformOrigin = `${event.clientX}px ${event.clientY}px`;
      stories.goToStory(index);
      stories.show();
    });
  });
});